import React from "react";
import { FunctionField } from "react-admin";
import { formatInYardTimeZone } from "../../utils/dateUtils";

/**
 * Replacement for react-admin's <DateField> for UTC timestamps.
 *
 * <DateField> formats with Date.toLocaleString() in the *viewer's browser*
 * time zone, so anyone outside the yard's zone sees a shifted time (a UTC
 * browser shows a 16:00Z / 8am Pacific booking as "4 PM"). This renders in
 * the reload yard's IANA time zone instead, matching the scheduler and edit
 * forms. Unlike DateField it ignores `locales`/`options` props; the format is
 * fixed MM/dd/yyyy (hh:mm a when showTime).
 */
/**
 * `fallbackSource` renders another field when `source` is empty — e.g. the
 * outbound placed time lives in placementDateTime, but records written before
 * the placement backfill only carry it in arrivalDateTime.
 */
export const YardDateField = ({
  source,
  fallbackSource,
  showTime,
  addLabel,
  ...props
}) => (
  <FunctionField
    {...props}
    source={source}
    render={(record) => {
      const value =
        record?.[source] || (fallbackSource ? record?.[fallbackSource] : null);
      if (!value) return "";
      return formatInYardTimeZone(
        new Date(value),
        showTime ? "MM/dd/yyyy hh:mm a" : "MM/dd/yyyy"
      );
    }}
  />
);

// SimpleShowLayout reads the element's addLabel prop to wrap fields in a
// <Labeled>; DateField supplied it via defaultProps, so this does too and
// stays labeled when dropped directly into a SimpleShowLayout/Tab. (Current
// call sites all wrap it in an explicit <Labeled>.)
YardDateField.defaultProps = { addLabel: true };
